import { Component, type ErrorInfo, type ReactNode } from "react"

import { logEvent } from "@/util/telemetry"

type ErrorBoundaryProps = {
  boundaryName: string
  boundaryData: Record<string, unknown>
  children: ReactNode
  errorMessage: ReactNode
}

type ErrorBoundaryState = { hasError: boolean }

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { boundaryName, boundaryData } = this.props

    logEvent("error", `ErrorBoundary: ${boundaryName}`, {
      exception: error,
      extra: {
        errorInfo,
        boundaryData,
      },
    })
  }

  render() {
    const { children, errorMessage } = this.props
    const { hasError } = this.state

    if (hasError) {
      return <>{errorMessage}</>
    }

    return children
  }
}
